import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '#app/components/ui/tabs.tsx'

export default function DanceOutLoud() {
	return (
		<div className="px-6 sm:px-8">
			<div className="mx-auto max-w-2xl pt-4 text-center">
				<h2 className="text-2xl font-bold tracking-tight text-white sm:text-4xl">
					Dance Out Loud
				</h2>
				<p className="text-[#f9c04d]">(Ages 10 & Up)</p>
				<p className="mt-6 text-sm font-bold text-stone-300 sm:text-base">
					With a variety of styles of dance offered and an array of incredible
					teachers, our Dance ou Loud summer program is a great place to come
					and have fun in a supportive environment with electric energy!
				</p>
			</div>
			<Tabs defaultValue="level2" className="mx-auto mt-12">
				<TabsList className="grid h-auto grid-cols-2 gap-4 bg-stone-800 p-0">
					<TabsTrigger
						value="level2"
						className="rounded-md px-3 py-2 text-sm font-medium text-stone-100 transition-colors hover:text-stone-100 data-[state='active']:bg-white data-[state='active']:text-stone-900"
					>
						Level 1/2, 2, 2/3
					</TabsTrigger>
					<TabsTrigger
						value="level3"
						className="rounded-md px-3 py-2 text-sm font-medium text-stone-100 transition-colors hover:text-stone-100 data-[state='active']:bg-white data-[state='active']:text-stone-900"
					>
						Level 3, 4
					</TabsTrigger>
				</TabsList>
				<TabsContent value="level2">
					<div className="mt-8 border-t border-stone-600 font-bold">
						<dl className="divide-y divide-stone-600 border-b border-stone-600">
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">
									Specialty class 1/2, 2, 2/3
								</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">12:30-1:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">
									Contemp/Lyrical 1/2, 2, 2/3
								</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">1:30-2:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Hip Hop 1/2, 2, 2/3</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">2:30-3:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Tap 1/2, 2, 2/3</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">3:30-4:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">
									Conditioning 1/2, 2, 2/3
								</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Thursdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">12:30-1:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Jazz 1/2, 2, 2/3</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Thursdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">1:30-3:00pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Ballet 1/2, 2, 2/3</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Thursdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">3:00-4:30pm</div>
									</div>
								</dd>
							</div>
						</dl>
						<div className="mx-auto max-w-xl space-y-4 pt-12 text-center">
							<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
								<div>
									<span className="text-[#f9c04d]">** </span>Tuesdays - July 7,
									14, 21, 28, August 4
								</div>

								<div>
									<span className="text-[#f9c04d]">** </span>Thursdays - July 9,
									16, 23, 30, August 6
								</div>
							</div>
							<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
								<div className="underline">Drop in fee:</div>
								<div className="ml-4">
									<div>
										Specialty class, Contemp/Lyrical, Hip Hop, Tap,
										Conditioning: $22
									</div>
									<div className="mt-2">Ballet, Jazz: $25</div>
								</div>
								<div className="mt-4 border-t border-stone-600 pt-4 underline">
									Five week session:
								</div>
								<div className="ml-4">
									<div>
										Conditioning, Speciality Class, Contemporary/Lyrical, Hip
										Hop, Tap: $100
									</div>
									<div className="mt-2">Ballet, Jazz: $115</div>
								</div>
							</div>
						</div>
					</div>
				</TabsContent>
				<TabsContent value="level3">
					<div className="mt-8 border-t border-stone-600 font-bold">
						<dl className="divide-y divide-stone-600 border-b border-stone-600">
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Contemp/Lyrical 3, 4</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">12:30-1:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Specialty class 3, 4</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">1:30-2:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Tap 3, 4</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">2:30-3:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Hip Hop 3, 4</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Tuesdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">3:30-4:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Conditioning 3, 4</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Thursdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">12:30-1:30pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Ballet 3, 4</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Thursdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">1:30-3:00pm</div>
									</div>
								</dd>
							</div>
							<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
								<dt className="text-sm text-stone-50">Jazz 3, 4</dt>
								<dd className="col-span-1 sm:col-span-2">
									<div className="grid grid-cols-2 text-sm text-stone-100">
										<div className="justify-center sm:grid">
											<div className="flex items-center gap-2">
												Thursdays
												<span className="inline-grid text-[#f9c04d]">**</span>
											</div>
										</div>
										<div className="grid justify-end">3:00-4:30pm</div>
									</div>
								</dd>
							</div>
						</dl>
						<div className="mx-auto max-w-xl space-y-4 pt-12 text-center">
							<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
								<div>
									<span className="text-[#f9c04d]">** </span>Tuesdays - July 7,
									14, 21, 28, August 4
								</div>

								<div>
									<span className="text-[#f9c04d]">** </span>Thursdays - July 9,
									16, 23, 30, August 6
								</div>
							</div>
							<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
								<div className="underline">Drop in fee:</div>
								<div className="ml-4">
									<div>
										Specialty class, Contemp/Lyrical, Hip Hop, Tap,
										Conditioning: $22
									</div>
									<div className="mt-2">Ballet, Jazz: $25</div>
								</div>
								<div className="mt-4 border-t border-stone-600 pt-4 underline">
									Five week session:
								</div>
								<div className="ml-4">
									<div>
										Conditioning, Speciality Class, Contemporary/Lyrical, Hip
										Hop, Tap: $100
									</div>
									<div className="mt-2">Ballet, Jazz: $115</div>
								</div>
							</div>
						</div>
					</div>
				</TabsContent>
			</Tabs>
		</div>
	)
}
